import { format } from 'date-fns';

const NA_TEXT = 'n/a';

export const formatUsd = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return NA_TEXT;
  }
  return `$${value.toLocaleString()}`;
};

export const formatCount = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return NA_TEXT;
  }
  return value.toLocaleString();
};

export const formatFollowers = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return NA_TEXT;
  }
  return `${value.toLocaleString()} followers`;
};

export const formatAddress = (
  address?: string | null,
  prefix: number = 6,
  suffix: number = 4
): string | null => {
  if (!address) {
    return null;
  }
  if (address.length <= prefix + suffix) {
    return address;
  }
  return `${address.slice(0, prefix)}...${address.slice(-suffix)}`;
};

export const formatDateTime = (
  date?: Date | string | null,
  pattern: string = 'MMM dd, yyyy HH:mm'
): string | null => {
  if (!date) {
    return null;
  }
  return format(new Date(date), pattern);
};

export const formatShortDateTime = (date?: Date | string | null): string | null =>
  formatDateTime(date, 'MMM dd, HH:mm');

export const formatTwitterHandle = (username?: string | null): string | null => {
  if (!username) {
    return null;
  }
  return `@${username}`;
};

export const formatPercent = (value?: number | null, fractionDigits: number = 1): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  return `${value.toFixed(fractionDigits)}%`;
};

export const formatCompactNumber = (value: number): string => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toLocaleString();
};

export const formatTimeAgoCompact = (createdAt?: Date | string | null): string => {
  if (!createdAt) return '';
  const now = new Date();
  const diffMs = now.getTime() - new Date(createdAt).getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffDays > 0) return `${diffDays}d`;
  if (diffHours > 0) return `${diffHours}h`;
  if (diffMinutes > 0) return `${diffMinutes}m`;
  return 'now';
};
